<google-chart
   [title]="lessonChartData?.title"
   [type]="lessonChartData?.chartType"
   [data]="lessonChartData?.dataTable"
   [columnNames]="lessonChartLabels"
   [options]="lessonChartData?.options"
></google-chart>

<google-chart
    [title]="boxesChartData.title"
    [type]="boxesChartData.chartType"
    [data]="boxesChartData.dataTable"
    [columnNames]="boxesChartLabels"
    [options]="boxesChartData.options"
></google-chart>

